import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import "./empresas.scss"

export const EmpresasSection = ({ classTitle }) => {
  return (
    <>
      <section className="empresas-section" id="Empresas">
        <div
          className="empresas-title-container"
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <div className="empresas-title">
            <h2 className="title-blue">Empresas que confían en</h2>
            <h2 className="title-orange">nuestras soluciones</h2>
          </div>
        </div>
        <div
          className="empresas-logos-container"
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <div className="empresas-logos">
            <ul className="empresas-logos-list">
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-1.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-2.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-3.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-4.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-5.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-6.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-7.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-8.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
              <li className="empresas-logo-item">
                <div className="logo-container">
                  <StaticImage
                    src="../../../images/home/empresas/logo-9.png"
                    alt={`${classTitle}-empresas-image`}
                    className={`${classTitle}-empresas-image`}
                    placeholder="blurred"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <StaticImage
          src="../../../images/poligonos/triangulo-naranja.svg"
          alt="triangulo-naranja"
          className="triangulo-naranja"
          placeholder="tracedSVG"
        />
      </section>
    </>
  )
}
